module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/doctor03-0ab57120b743b38c0d3b6241468692d0.png";